'use client';

// ─────────────────────────────────────────────────────────────────────────────
// ScheduleTab — weekly calendar.
//
// (Virtual Meetings removed — the company uses Google Meet.) CalendarWidget
// owns its own data fetch and `schedule_realtime` subscription.
// ─────────────────────────────────────────────────────────────────────────────

import CalendarWidget from '../CalendarWidget';

export default function ScheduleTab() {
  return (
    <div className="min-h-[380px]">
      <CalendarWidget />
    </div>
  );
}
